import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import BasicLayout from '@/layouts/BasicLayout';
/**
 * 优惠券
 */

export default {
  path: '/coupon',
  component: BasicLayout,
  redirect: '/coupon',
  children: [{
    path: '/coupon',
    name: 'couponList',
    component: function component() {
      return import('views/coupon/Coupon');
    },
    meta: {
      title: '优惠券'
    }
  }]
};